/**
 *
 * @description 兑换官方优惠券 - 直接兑换
 * @time 2022/6/17 17:47
 *
 */

import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { inject } from 'mobx-react';
import styles from './index.module.less';
import SubmitBtn from '@/components/SubmitBtn';
import MiddleModal from '@/components/MiddleModal';
import { message } from 'antd';

const Index = inject(
  'area',
  'gold',
  'app'
)(
  forwardRef((props, ref) => {
    const { LANG } = props.area;
    const { productDetail, onExchangeProductSuccess } = props;
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
      toggleVisible,
    }));

    const toggleVisible = (visible) => {
      setVisible(visible);
    };

    const handleSubmit = async () => {
      props.app.setGlobalValue('G_GlobalLoading', true);
      const { exChangeProduct } = props.gold;
      const { code, msg } = await exChangeProduct(productDetail.id);
      props.app.setGlobalValue('G_GlobalLoading', false);
      switch (code) {
        case 0:
          onExchangeProductSuccess();
          break;
        case 5003:
        case 5004:
          message.warning(LANG['product.notAvailable']);
          break;
        case 5005:
          message.warning(LANG['product.notExist']);
          break;
        case 16000:
          message.warning(LANG['product.goldNotEnough']);
          break;
        case 21428:
          message.warning(LANG['product.tmpOverdue']);
          break;
        default:
          message.warning(code);
      }
      toggleVisible(false);
    };

    return (
      <MiddleModal
        title={LANG['product.redemptionInfo']}
        footer={null}
        theme='float'
        visible={visible}
        wrapClassName={styles.submitModal}
        onCancel={() => toggleVisible(false)}
      >
        <div className={styles.modalContent}>
          <div className={styles.cover}>
            <img src={productDetail.cover} alt='' />
          </div>
          <div className={styles.info}>
            <p className={styles.name}>{productDetail?.info?.title}</p>
            <p className={styles.count}>{LANG['common.label.quantity']}：1</p>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <span className={styles.point}>
            {LANG['common.label.gold']}:{productDetail.points}
          </span>
          <div className={styles.btnGroup}>
            <SubmitBtn className={styles.cancel} onClick={() => toggleVisible(false)}>
              {LANG['common.btn.cancel']}
            </SubmitBtn>
            <SubmitBtn className={styles.submit} onClick={handleSubmit}>
              {LANG['common.btn.redeemNow']}
            </SubmitBtn>
          </div>
        </div>
      </MiddleModal>
    );
  })
);

export default Index;
